import { request } from '@/util/http'

export const getUser = (id) => {
  return request({
    url: '/health/userDoctor/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const getList = (current, size, params) => {
  return request({
    url: '/health/userDoctor/list',
    method: 'get',
    params: {
      ...params,
      current,
      size
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/health/userDoctor/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/health/userDoctor/remove',
    method: 'post',
    params: {
      ids
    }
  })
}

export const submit = (row) => {
  return request({
    url: '/health/userDoctor/submit',
    method: 'post',
    data: row
  })
}

